import { type DateQuickFilter } from '@/features/shared/hooks/useDateWindow';
import { s } from '@/theme/tokens';
import { Box, PanelHeadingText } from '@/ui';
import type { ReactElement } from 'react';

export const COVERAGE_CHART_PAGE_SIZE = 100;
export const COVERAGE_TIMELINE_CHART_HEIGHT = 132;
export const COVERAGE_TIMELINE_MARGIN_BOTTOM = 4;
export const COVERAGE_TIMELINE_X_AXIS_HEIGHT = 28;
export const COVERAGE_TIMELINE_Y_AXIS_WIDTH = 40;
export const COVERAGE_TIMELINE_Y_AXIS_TICKS = [0, 50, 100];
export const COVERAGE_TIMELINE_MARGIN_LEFT = -8;
export const COVERAGE_TIMELINE_MARGIN_RIGHT = 20;
export const COVERAGE_TIMELINE_MARGIN_TOP = 12;
export const COVERAGE_TIMELINE_AXIS_STROKE_WIDTH = 0.75;
export const COVERAGE_TIMELINE_Y_DOMAIN_PADDING_TOP_RATIO = 0.1;
export const COVERAGE_TIMELINE_Y_DOMAIN_PADDING_BOTTOM_RATIO = 0.05;
export const COVERAGE_TIMELINE_Y_AXIS_MAX = 100;
export const COVERAGE_TIMELINE_CHART_LIFT = '-16px';
export const COVERAGE_TIMELINE_PLOT_LEFT_GUTTER = 6;
export const COVERAGE_TIMELINE_PLOT_RIGHT_GUTTER = 6;

export const buildCoverageTimelineHeader = (title: string): ReactElement => (
  <Box
    sx={{
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'space-between',
      columnGap: s('lg'),
      rowGap: s('xs'),
      px: s('md'),
      minHeight: '28px',
      boxSizing: 'border-box',
      position: 'relative',
      zIndex: 1,
    }}
  >
    <PanelHeadingText
      component="h2"
      sx={{
        minWidth: 0,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      {title}
    </PanelHeadingText>
  </Box>
);

export const resolveCoverageComparisonWindowLabel = (
  quickFilter: DateQuickFilter,
): string | null => {
  switch (quickFilter) {
    case '7d':
      return 'Last 7 days';
    case '14d':
      return 'Last 14 days';
    case '30d':
      return 'Last 30 days';
    case '90d':
      return 'Last 90 days';
    case 'latest':
    default:
      return null;
  }
};

export const toDateStartIso = (day: string | null): string | null =>
  day ? `${day}T00:00:00.000Z` : null;

export const toDateEndIso = (day: string | null): string | null =>
  day ? `${day}T23:59:59.999Z` : null;
